import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TractorsGridComponent } from './tractors-grid.component';
import { TabModule } from '../tab/tab.module';
import { DxDataGridModule, DxSwitchModule, } from 'devextreme-angular';
import { GridDefaultModule, GridTitleModule, TrackerChooserModule } from 'shared';
import { UserDomainsChooserModule } from '../user-domains/user-domains-chooser/user-domains-chooser.module';



@NgModule({
  declarations: [TractorsGridComponent],
  imports: [
    CommonModule,
    TabModule,
    DxDataGridModule,
    TrackerChooserModule,
    UserDomainsChooserModule,
    GridTitleModule,
    DxSwitchModule,
    GridDefaultModule
  ],
  exports: [TractorsGridComponent]
})
export class TractorsGridModule { }
